import React from "react";
import { Link } from "react-router-dom";
import { agendarUrl } from "../constants";

const BookUsBanner = ({
  title = "¿Necesitas una consulta para tu mascota?",
  description = "Contáctanos hoy mismo y agenda una cita con nuestros especialistas.",
  buttonText = "Agendar Consulta",
  buttonUrl = agendarUrl,
  id = null,
}) => {
  return (
    <section className="relative z-10 pb-[110px]">
      <div className="container">
        <div
          {...(id && { id })}
          className="wow fadeInUp rounded-2xl bg-gradient-1 py-[60px] px-8 sm:py-20 sm:px-14"
          data-wow-delay=".2s"
        >
          <div className="flex flex-wrap items-center justify-center -mx-4">
            <div className="w-full px-4 lg:w-1/2">
              <div className="mb-10 lg:mb-0">
                <h2 className="mb-6 text-3xl font-bold leading-tight text-white sm:text-4xl sm:leading-tight md:text-[40px] md:leading-tight lg:text-[42px] lg:leading-tight">
                  {title}
                </h2>
                <p className="text-base text-white">{description}</p>
              </div>
            </div>
            <div className="w-full px-4 lg:w-1/2">
              <div className="flex flex-wrap items-center justify-end">
                <Link
                  to={buttonUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 text-base font-medium text-black transition-all bg-white rounded-md hover:bg-white/90"
                >
                  {buttonText}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookUsBanner;
